import * as ng from 'angular';

export class OrganViewPanelDataProcessingTomsComponent implements ng.IComponentOptions {
    public template = require('./toms.html');
}
